import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";
import {
  BreakPointMobile,
  BreakPointTablet,
} from "../../../constants/dimension";

export const useStyles = createUseStyles((theme: ITheme) => ({
  row: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space8,
    width: "100%",
    boxSizing: "border-box",
    marginInline: "auto",
    marginTop: theme.spacing.space20,
    paddingInline: theme.spacing.space16,
    [BreakPointMobile]: {
      maxWidth: "100% !important",
    },
    [BreakPointTablet]: {
      maxWidth: "100% !important",
    },
  },
  rowLarge: {
    paddingInline: 0,
  },
  boxes: {
    display: "grid",
    justifyContent: "center",
    gap: theme.spacing.space8,
  },
  boxesLarge: {
    gap: theme.spacing.space12,
  },
  box: {
    minWidth: 0,
    "& input": {
      width: "100% !important",
    },
  },
  boxError: {
    "& input": {
      borderColor: `${theme.colors.NotificationError} !important`,
    },
  },
  input: {
    width: 60,
    height: 68,
    paddingBlock: theme.spacing.space12,
    paddingInline: 0,
    boxSizing: "border-box",
    textAlign: "center",
    letterSpacing: 0,
    color: theme.colors.TextDefault,
    background: "transparent",
    border: `1px solid ${theme.colors.Border1}`,
    borderRadius: theme.radius.small,
    fontSize: 24,
    fontWeight: 700,
    [BreakPointMobile]: {
      height: 56,
      fontSize: 20,
    },
  },
  selected: {
    boxSizing: "border-box",
    outline: `1px solid ${theme.colors.Border4}`,
    outlineOffset: 4,
    borderRadius: theme.radius.small,
  },
}));
